var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeSideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0822 6.43511L4.31882 13.2284C3.65306 13.811 4.09944 14.8457 5.01651 14.8457C5.57679 14.8457 6.03098 15.2652 6.03098 15.7827V20.1074C6.03098 23.828 6.03098 25.6883 7.28235 26.8442C8.53372 28 10.5478 28 14.5759 28H17.4241C21.4522 28 23.4663 28 24.7177 26.8442C25.969 25.6883 25.969 23.828 25.969 20.1074V15.7827C25.969 15.2652 26.4232 14.8457 26.9835 14.8457C27.9006 14.8457 28.3469 13.811 27.6812 13.2284L19.9178 6.43511C18.0626 4.8117 17.135 4 16 4C14.865 4 13.9374 4.8117 12.0822 6.43511Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeSideMenu);
export default __webpack_public_path__ + "static/media/icon-home-side-menu.e2d76210ad97be4ab14b932165d313a8.svg";
export { ForwardRef as ReactComponent };